import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 16px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.black3};
  position: relative;

  .ant-form {
    display: flex;
    flex-direction: column;
    gap: 20px !important;
  }
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black9};
`;

export const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    flex-direction: row;
    align-items: center;
  }
`;

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 300px;

  .ant-form-item {
    margin-bottom: 8px !important;
  }
  .ant-form-list {
    margin-bottom: 10px !important;
  }
  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    min-width: 200px;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ItemTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black9};
`;

export const ItemValue = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.black9};
`;

export const ItemLink = styled.a`
  color: ${({ theme }) => theme.colors.black9};
  text-decoration: none;
  cursor: pointer;
`;

export const Actions = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
`;
